// Batch 34 · fork d: W9 basis of the comparison (Z-12), rows set "Resolved" (Z-13), the report's "[to complete]" list (Z-14),
// recoverable VAT on unrecorded-liability rows (Z-15), "Link to an existing misstatement" (Z-16), the sign rule (Z-17).
// EN + AR, merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B34D = {
  en: {
    b34d: {
      basisTitle: "Basis of the comparison with materiality",
      basisNet: "Net effect (default)",
      basisGross: "Gross effect (compare gross)",
      basisUsedNet: "The conclusion compares the NET effect on profit before tax and on net assets with materiality.",
      basisUsedGross: "The conclusion compares the GROSS effect (sum of the absolute effects) with materiality — chosen for this engagement.",
      netCompared: "Net: compared {v}",
      grossCompared: "Gross: compared {v}",
      promptBasis: "Basis: {b}",
      net: "net", gross: "gross",
      signNote: "Effect of the correcting entry: negative = the correction reduces profit / net assets",
      countedResolved: "Group \"Resolved\" but not corrected by management — counted in the uncorrected totals",
      correctedTitle: "Corrected misstatements — total",
      correctedNote: "Rows management corrected, whatever their group. Not part of the uncorrected totals.",
      linkedFrom: "Linked from",
      unfilledTitle: "Still to complete in the report text ({n})",
      vat: "Recoverable VAT",
      net_: "Amount excl. VAT",
      vatFromFile: "VAT from the file",
      vatNeeded: "Give the VAT (or the amount excl. VAT) before Send — the expense is the amount excluding VAT.",
      vatInvalid: "The VAT is between 0 and the row's amount.",
      linkExisting: "Link to an existing misstatement",
      linkTitle: "Link this row to an existing misstatement",
      linkIntro: "Pick the misstatement already on the Misstatements page for this item. No second row is created; this row counts as sent.",
      linkNone: "No misstatements on this engagement yet.",
      linkPick: "Link",
      linked: "Linked to the existing misstatement — this row counts as sent.",
      linkedBadge: "Linked",
      unlink: "Unlink",
      unlinked: "Link removed — the row is not sent.",
      cancel: "Cancel",
    },
  },
  ar: {
    b34d: {
      basisTitle: "أساس المقارنة مع الأهمية النسبية",
      basisNet: "الأثر الصافي (افتراضي)",
      basisGross: "الأثر الإجمالي (مقارنة إجمالية)",
      basisUsedNet: "يقارن الاستنتاج الأثر الصافي على الربح قبل الضريبة وعلى صافي الأصول مع الأهمية النسبية.",
      basisUsedGross: "يقارن الاستنتاج الأثر الإجمالي (مجموع القيم المطلقة للآثار) مع الأهمية النسبية — اختير لهذا الارتباط.",
      netCompared: "الصافي: المقارَن {v}",
      grossCompared: "الإجمالي: المقارَن {v}",
      promptBasis: "الأساس: {b}",
      net: "صافٍ", gross: "إجمالي",
      signNote: "أثر قيد التصحيح: السالب = التصحيح يخفض الربح / صافي الأصول",
      countedResolved: "المجموعة \"محسومة\" لكن الإدارة لم تصححها — تُحتسب ضمن مجاميع التحريفات غير المصححة",
      correctedTitle: "التحريفات المصححة — المجموع",
      correctedNote: "الصفوف التي صححتها الإدارة أياً كانت مجموعتها. لا تدخل في مجاميع التحريفات غير المصححة.",
      linkedFrom: "مرتبط من",
      unfilledTitle: "ما زال مطلوب إكماله في نص التقرير ({n})",
      vat: "ضريبة القيمة المضافة القابلة للاسترداد",
      net_: "المبلغ قبل الضريبة",
      vatFromFile: "الضريبة من الملف",
      vatNeeded: "أدخل الضريبة (أو المبلغ قبل الضريبة) قبل الإرسال — المصروف هو المبلغ دون الضريبة.",
      vatInvalid: "ضريبة القيمة المضافة بين صفر ومبلغ الصف.",
      linkExisting: "ربط بتحريف موجود",
      linkTitle: "اربط هذا الصف بتحريف موجود",
      linkIntro: "اختر التحريف الموجود مسبقاً في صفحة التحريفات لهذا البند. لا يُنشأ صف ثانٍ؛ ويُعد هذا الصف مُرسلاً.",
      linkNone: "لا توجد تحريفات في هذا الارتباط بعد.",
      linkPick: "ربط",
      linked: "رُبط بالتحريف الموجود — يُعد هذا الصف مُرسلاً.",
      linkedBadge: "مرتبط",
      unlink: "إلغاء الربط",
      unlinked: "أُزيل الربط — الصف غير مُرسل.",
      cancel: "إلغاء",
    },
  },
};

export default I18N_B34D;
